var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error',{attrs:{"text":"ERROR DE CONEXION"}})
}
var staticRenderFns = []

export { render, staticRenderFns }